<template>
  <div class="bill-wp-revision">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="overview">
        <div id="graph" style="height: 300px"></div>
        <div class="title">{{ frDate }} 分润</div>
      </div>
      <div class="detail">
        <div
          class="title"
          style="position: sticky; top: 0"
          @click="dropDown = !dropDown"
        >
          <span>交易详情</span>
          <span>
            <van-icon name="arrow-up" v-show="dropDown" />
            <van-icon name="arrow-down" v-show="!dropDown" />
          </span>
        </div>
        <div v-show="dropDown">
          <div class="list-title">
            <div>分润交易类型</div>
            <div>自身交易</div>
            <div>整体交易</div>
          </div>
          <div class="list" v-for="(item, index) in list" :key="index">
            <div>
              {{ item.tradeName }}
            </div>
            <div>
              {{ item.selfMoney }}
            </div>
            <div>
              {{ item.allMoney }}
            </div>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="title">分润明细</div>

        <div class="info" v-for="first in info" :key="first.key">
          <div class="first-key">
            <i class="block"></i>
            {{ first.key }}
          </div>
          <div v-for="(second, key) in first.child" :key="key" class="second">
            <div v-for="sChild in second" :key="sChild.key" class="second-item">
              <div>{{ sChild.key }}</div>
              <div class="right">{{ sChild.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { formatMoney } from '@/utils/utils'
import { getFrDetails, getFrDataList } from '@/api/profit/profit'
import { Toast } from 'vant'
import * as echarts from 'echarts/core'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import { PieChart } from 'echarts/charts'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
export default {
  filters: {
    formatMoney
  },
  data() {
    return {
      list: [],
      dropDown: false,
      info: [],
      isLoading: false,
      frDate: this.$route.query.frDate || '2021-10',
      graphData: []
    }
  },
  created() {
    this.init()
    // let allInfo = [
    //   {
    //     allMoney: 200,
    //     remark: '管理分润'
    //   },
    //   {
    //     allMoney: 100,
    //     remark: '钻石分润'
    //   },
    //   {
    //     allMoney: 0,
    //     remark: '基础分润'
    //   },
    //   {
    //     allMoney: 0,
    //     remark: '皇冠分润'
    //   }
    // ]
    // this.formatGraphData(allInfo)
  },
  mounted() {
    this.initGraph()
  },
  methods: {
    init() {
      getFrDataList({
        frDate: this.frDate
      }).then(res => {
        this.list = res || []
        console.log('分润交易详情:', res)
      })
      getFrDetails({
        frDate: this.frDate
      }).then(result => {
        console.log('分润详情: ', result)
        this.info = result.frInfo || {}
        this.formatGraphData(result.allInfo)
        if (JSON.stringify(this.info) == '{}') {
          Toast('未查到分润明细数据')
        }
      })
    },
    formatGraphData(data) {
      this.graphData = []
      let noData = true
      for (let item of data) {
        this.graphData.push({
          name: item.remark,
          value: item.allMoney || null
        })
        if (item.allMoney) {
          noData = false
        }
      }
      this.initGraph(noData)
    },
    initGraph(noData) {
      // 初始化饼图
      echarts.use([
        TitleComponent,
        TooltipComponent,
        LegendComponent,
        PieChart,
        CanvasRenderer,
        LabelLayout
      ])

      var chartDom = document.getElementById('graph')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        title: {
          show: noData, // 没数据时显示title
          text: '暂无数据',
          left: 'center',
          top: 'center',
          textStyle: {
            color: 'pink',
            fontSize: 16,
            fontWeight: 400
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: 'left'
        },
        series: [
          {
            name: '分润明细',
            type: 'pie',
            radius: ['50%', '70%'],
            data: this.graphData,
            itemStyle: {
              normal: {
                label: {
                  formatter: `{b}
{d}%`
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    onRefresh() {
      this.init()
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    }
  }
}
</script>
